module.exports = __webpack_public_path__ + "img/image3.37683d04.jpeg";